import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StreamContainerDetailFragment = { __typename?: 'StreamContainer', id: string, created: string, updated: string, environmentId: string, streamId: string, enabled?: boolean | null, name: string, isDefault?: boolean | null, cardLimit: number, filter: Array<unknown | null>, themeId: string, darkThemeId?: string | null, stream?: { __typename?: 'Stream', name: string } | null, theme?: { __typename?: 'Theme', name: string } | null, darkTheme?: { __typename?: 'Theme', name: string } | null };

export type StreamContainerListQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  orderBy?: Array<Types.StreamContainersOrderBy> | Types.StreamContainersOrderBy;
}>;


export type StreamContainerListQuery = { __typename?: 'Query', streamContainers?: { __typename?: 'StreamContainersConnection', totalCount: number, nodes: Array<{ __typename?: 'StreamContainer', id: string, created: string, updated: string, environmentId: string, streamId: string, enabled?: boolean | null, name: string, isDefault?: boolean | null, cardLimit: number, filter: Array<unknown | null>, themeId: string, darkThemeId?: string | null, stream?: { __typename?: 'Stream', name: string } | null, theme?: { __typename?: 'Theme', name: string } | null, darkTheme?: { __typename?: 'Theme', name: string } | null }> } | null };

export type GetStreamContainerQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type GetStreamContainerQuery = { __typename?: 'Query', streamContainer?: { __typename?: 'StreamContainer', id: string, created: string, updated: string, environmentId: string, streamId: string, enabled?: boolean | null, name: string, isDefault?: boolean | null, cardLimit: number, filter: Array<unknown | null>, themeId: string, darkThemeId?: string | null, stream?: { __typename?: 'Stream', name: string } | null, theme?: { __typename?: 'Theme', name: string } | null, darkTheme?: { __typename?: 'Theme', name: string } | null } | null };

export type AddStreamContainerMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
  streamId: Types.Scalars['String']['input'];
  themeId: Types.Scalars['String']['input'];
  darkThemeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  cardLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filter?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['JSON']['input']>> | Types.InputMaybe<Types.Scalars['JSON']['input']>>;
}>;


export type AddStreamContainerMutation = { __typename?: 'Mutation', createStreamContainer?: { __typename?: 'CreateStreamContainerPayload', streamContainer?: { __typename?: 'StreamContainer', id: string, created: string, updated: string, environmentId: string, streamId: string, enabled?: boolean | null, name: string, isDefault?: boolean | null, cardLimit: number, filter: Array<unknown | null>, themeId: string, darkThemeId?: string | null, stream?: { __typename?: 'Stream', name: string } | null, theme?: { __typename?: 'Theme', name: string } | null, darkTheme?: { __typename?: 'Theme', name: string } | null } | null } | null };

export type EditStreamContainerMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  streamId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  themeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  darkThemeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  enabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  cardLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filter?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['JSON']['input']>> | Types.InputMaybe<Types.Scalars['JSON']['input']>>;
}>;


export type EditStreamContainerMutation = { __typename?: 'Mutation', updateStreamContainer?: { __typename?: 'UpdateStreamContainerPayload', streamContainer?: { __typename?: 'StreamContainer', id: string, created: string, updated: string, environmentId: string, streamId: string, enabled?: boolean | null, name: string, isDefault?: boolean | null, cardLimit: number, filter: Array<unknown | null>, themeId: string, darkThemeId?: string | null, stream?: { __typename?: 'Stream', name: string } | null, theme?: { __typename?: 'Theme', name: string } | null, darkTheme?: { __typename?: 'Theme', name: string } | null } | null } | null };

export type DeleteStreamContainerMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type DeleteStreamContainerMutation = { __typename?: 'Mutation', deleteStreamContainer?: { __typename?: 'DeleteStreamContainerPayload', streamContainer?: { __typename?: 'StreamContainer', id: string, created: string, updated: string, environmentId: string, streamId: string, enabled?: boolean | null, name: string, isDefault?: boolean | null, cardLimit: number, filter: Array<unknown | null>, themeId: string, darkThemeId?: string | null, stream?: { __typename?: 'Stream', name: string } | null, theme?: { __typename?: 'Theme', name: string } | null, darkTheme?: { __typename?: 'Theme', name: string } | null } | null } | null };

export type SetDefaultStreamContainerMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  streamContainerId: Types.Scalars['String']['input'];
}>;


export type SetDefaultStreamContainerMutation = { __typename?: 'Mutation', setDefaultStreamContainer?: { __typename?: 'SetDefaultStreamContainerPayload', streamContainers?: Array<{ __typename?: 'StreamContainer', id: string, created: string, updated: string, environmentId: string, streamId: string, enabled?: boolean | null, name: string, isDefault?: boolean | null, cardLimit: number, filter: Array<unknown | null>, themeId: string, darkThemeId?: string | null, stream?: { __typename?: 'Stream', name: string } | null, theme?: { __typename?: 'Theme', name: string } | null, darkTheme?: { __typename?: 'Theme', name: string } | null }> | null } | null };

export const StreamContainerDetailFragmentDoc = gql`
    fragment StreamContainerDetail on StreamContainer {
  id
  created
  updated
  environmentId
  streamId
  enabled
  name
  isDefault
  cardLimit
  filter
  stream: environmentStream {
    name
  }
  themeId
  theme: environmentTheme {
    name
  }
  darkThemeId
  darkTheme: environmentDarkTheme {
    name
  }
}
    `;
export const StreamContainerListDocument = gql`
    query StreamContainerList($environmentId: String!, $orderBy: [StreamContainersOrderBy!]! = [UPDATED_DESC]) {
  streamContainers(orderBy: $orderBy, condition: {environmentId: $environmentId}) {
    nodes {
      ...StreamContainerDetail
    }
    totalCount
  }
}
    ${StreamContainerDetailFragmentDoc}`;

/**
 * __useStreamContainerListQuery__
 *
 * To run a query within a React component, call `useStreamContainerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStreamContainerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamContainerListQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useStreamContainerListQuery(baseOptions: Apollo.QueryHookOptions<StreamContainerListQuery, StreamContainerListQueryVariables> & ({ variables: StreamContainerListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StreamContainerListQuery, StreamContainerListQueryVariables>(StreamContainerListDocument, options);
      }
export function useStreamContainerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StreamContainerListQuery, StreamContainerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StreamContainerListQuery, StreamContainerListQueryVariables>(StreamContainerListDocument, options);
        }
export function useStreamContainerListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StreamContainerListQuery, StreamContainerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StreamContainerListQuery, StreamContainerListQueryVariables>(StreamContainerListDocument, options);
        }
export type StreamContainerListQueryHookResult = ReturnType<typeof useStreamContainerListQuery>;
export type StreamContainerListLazyQueryHookResult = ReturnType<typeof useStreamContainerListLazyQuery>;
export type StreamContainerListSuspenseQueryHookResult = ReturnType<typeof useStreamContainerListSuspenseQuery>;
export type StreamContainerListQueryResult = Apollo.QueryResult<StreamContainerListQuery, StreamContainerListQueryVariables>;
export const GetStreamContainerDocument = gql`
    query GetStreamContainer($id: String!, $environmentId: String!) {
  streamContainer(id: $id, environmentId: $environmentId) {
    ...StreamContainerDetail
  }
}
    ${StreamContainerDetailFragmentDoc}`;

/**
 * __useGetStreamContainerQuery__
 *
 * To run a query within a React component, call `useGetStreamContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamContainerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetStreamContainerQuery(baseOptions: Apollo.QueryHookOptions<GetStreamContainerQuery, GetStreamContainerQueryVariables> & ({ variables: GetStreamContainerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamContainerQuery, GetStreamContainerQueryVariables>(GetStreamContainerDocument, options);
      }
export function useGetStreamContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamContainerQuery, GetStreamContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamContainerQuery, GetStreamContainerQueryVariables>(GetStreamContainerDocument, options);
        }
export function useGetStreamContainerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStreamContainerQuery, GetStreamContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStreamContainerQuery, GetStreamContainerQueryVariables>(GetStreamContainerDocument, options);
        }
export type GetStreamContainerQueryHookResult = ReturnType<typeof useGetStreamContainerQuery>;
export type GetStreamContainerLazyQueryHookResult = ReturnType<typeof useGetStreamContainerLazyQuery>;
export type GetStreamContainerSuspenseQueryHookResult = ReturnType<typeof useGetStreamContainerSuspenseQuery>;
export type GetStreamContainerQueryResult = Apollo.QueryResult<GetStreamContainerQuery, GetStreamContainerQueryVariables>;
export const AddStreamContainerDocument = gql`
    mutation AddStreamContainer($environmentId: String!, $name: String!, $streamId: String!, $themeId: String!, $darkThemeId: String, $cardLimit: Int, $filter: [JSON]) {
  createStreamContainer(
    input: {streamContainer: {name: $name, environmentId: $environmentId, streamId: $streamId, themeId: $themeId, darkThemeId: $darkThemeId, cardLimit: $cardLimit, filter: $filter}}
  ) {
    streamContainer {
      ...StreamContainerDetail
    }
  }
}
    ${StreamContainerDetailFragmentDoc}`;

/**
 * __useAddStreamContainerMutation__
 *
 * To run a mutation, you first call `useAddStreamContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStreamContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStreamContainerMutation, { data, loading, error }] = useAddStreamContainerMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *      streamId: // value for 'streamId'
 *      themeId: // value for 'themeId'
 *      darkThemeId: // value for 'darkThemeId'
 *      cardLimit: // value for 'cardLimit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAddStreamContainerMutation(baseOptions?: Apollo.MutationHookOptions<AddStreamContainerMutation, AddStreamContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStreamContainerMutation, AddStreamContainerMutationVariables>(AddStreamContainerDocument, options);
      }
export type AddStreamContainerMutationHookResult = ReturnType<typeof useAddStreamContainerMutation>;
export type AddStreamContainerMutationResult = Apollo.MutationResult<AddStreamContainerMutation>;
export type AddStreamContainerMutationOptions = Apollo.BaseMutationOptions<AddStreamContainerMutation, AddStreamContainerMutationVariables>;
export const EditStreamContainerDocument = gql`
    mutation EditStreamContainer($id: String!, $environmentId: String!, $name: String, $streamId: String, $themeId: String, $darkThemeId: String, $enabled: Boolean, $cardLimit: Int, $filter: [JSON]) {
  updateStreamContainer(
    input: {id: $id, environmentId: $environmentId, patch: {name: $name, streamId: $streamId, themeId: $themeId, darkThemeId: $darkThemeId, enabled: $enabled, cardLimit: $cardLimit, filter: $filter}}
  ) {
    streamContainer {
      ...StreamContainerDetail
    }
  }
}
    ${StreamContainerDetailFragmentDoc}`;

/**
 * __useEditStreamContainerMutation__
 *
 * To run a mutation, you first call `useEditStreamContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStreamContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStreamContainerMutation, { data, loading, error }] = useEditStreamContainerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *      streamId: // value for 'streamId'
 *      themeId: // value for 'themeId'
 *      darkThemeId: // value for 'darkThemeId'
 *      enabled: // value for 'enabled'
 *      cardLimit: // value for 'cardLimit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEditStreamContainerMutation(baseOptions?: Apollo.MutationHookOptions<EditStreamContainerMutation, EditStreamContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditStreamContainerMutation, EditStreamContainerMutationVariables>(EditStreamContainerDocument, options);
      }
export type EditStreamContainerMutationHookResult = ReturnType<typeof useEditStreamContainerMutation>;
export type EditStreamContainerMutationResult = Apollo.MutationResult<EditStreamContainerMutation>;
export type EditStreamContainerMutationOptions = Apollo.BaseMutationOptions<EditStreamContainerMutation, EditStreamContainerMutationVariables>;
export const DeleteStreamContainerDocument = gql`
    mutation DeleteStreamContainer($id: String!, $environmentId: String!) {
  deleteStreamContainer(input: {id: $id, environmentId: $environmentId}) {
    streamContainer {
      ...StreamContainerDetail
    }
  }
}
    ${StreamContainerDetailFragmentDoc}`;

/**
 * __useDeleteStreamContainerMutation__
 *
 * To run a mutation, you first call `useDeleteStreamContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStreamContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStreamContainerMutation, { data, loading, error }] = useDeleteStreamContainerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useDeleteStreamContainerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStreamContainerMutation, DeleteStreamContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStreamContainerMutation, DeleteStreamContainerMutationVariables>(DeleteStreamContainerDocument, options);
      }
export type DeleteStreamContainerMutationHookResult = ReturnType<typeof useDeleteStreamContainerMutation>;
export type DeleteStreamContainerMutationResult = Apollo.MutationResult<DeleteStreamContainerMutation>;
export type DeleteStreamContainerMutationOptions = Apollo.BaseMutationOptions<DeleteStreamContainerMutation, DeleteStreamContainerMutationVariables>;
export const SetDefaultStreamContainerDocument = gql`
    mutation setDefaultStreamContainer($environmentId: String!, $streamContainerId: String!) {
  setDefaultStreamContainer(
    input: {environmentId: $environmentId, streamContainerId: $streamContainerId}
  ) {
    streamContainers {
      ...StreamContainerDetail
    }
  }
}
    ${StreamContainerDetailFragmentDoc}`;

/**
 * __useSetDefaultStreamContainerMutation__
 *
 * To run a mutation, you first call `useSetDefaultStreamContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultStreamContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultStreamContainerMutation, { data, loading, error }] = useSetDefaultStreamContainerMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      streamContainerId: // value for 'streamContainerId'
 *   },
 * });
 */
export function useSetDefaultStreamContainerMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultStreamContainerMutation, SetDefaultStreamContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultStreamContainerMutation, SetDefaultStreamContainerMutationVariables>(SetDefaultStreamContainerDocument, options);
      }
export type SetDefaultStreamContainerMutationHookResult = ReturnType<typeof useSetDefaultStreamContainerMutation>;
export type SetDefaultStreamContainerMutationResult = Apollo.MutationResult<SetDefaultStreamContainerMutation>;
export type SetDefaultStreamContainerMutationOptions = Apollo.BaseMutationOptions<SetDefaultStreamContainerMutation, SetDefaultStreamContainerMutationVariables>;